import styled from 'styled-components';

export const FlexDiv = styled.div`
  display: flex;
  align-items: center;
`;

export const HeaderTitle = styled.span`
  font-weight: 600;
  font-family: 'Poppins';
`;

export const StyledMobileHeader = styled.div`
  display: none;

  @media only screen and (max-width: 1100px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    height: 50px;
    padding: 0 5.333vw;
    background-color: #0171cf;
    color: white;
    z-index: 1;
    box-sizing: border-box;

    .demo-icon {
      width: 7vw;
      margin-right: 4vw;
      max-height: 40px;
      path {
        fill: white;
      }
    }

    .icon-close {
      display: block;
      width: 23px;
      padding: 6px;
      background-color: #01579f;
      border-radius: 100%;
      box-sizing: border-box;

      path {
        fill: white;
      }
    }
  }
`;

export default StyledMobileHeader;
